import { render } from "./VitrineCarousel.vue?vue&type=template&id=a009b564"
import script from "./VitrineCarousel.vue?vue&type=script&lang=js"
export * from "./VitrineCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__